const theme = {
  colors: {
    primary: "blue",
    secondary: "red",
    danger: "red",
  },

  size: {
    sm: "font-size: 0.8rem; padding: 0.2rem 0.5rem",
    md: "font-size: 1rem; padding: 0.5rem 1rem",
    lg: "font-size: 1.3rem; padding: 0.5rem 1rem",
  },
};

export default theme;
